import { PropsWithChildren } from 'react'
import { useLocation, Navigate } from "react-router-dom";
import { useHasAccess } from './RevenueCatProvider';
import { MembershipType } from './paywall.model';

type RequireAccessProps = { membership: MembershipType } & PropsWithChildren;

export const RequireAccess = ({ children, membership }: RequireAccessProps) => {
  const location = useLocation();
  const [hasAccess] = useHasAccess(membership);

  if (!hasAccess) {
    return <Navigate to="/pricing" state={{ from: location }} replace />;
  } else {
    return children;
  }
}